<template>
    <div class="floor-style-1 floor-wsw" :id="data.block_name + c_index">
        <div class="head-wrap" v-if="data.value.title.value.text">
            <h2 @click="$router.pushToTab(data.value.title.value.link.url)"
                :style="{ color: data.value.title.value.color }">{{ data.value.title.value.text }}</h2>
        </div>
        <div class="body-wrap">
            <div class="left-wrap" v-if="data.value.leftImg.value.url">
                <img :src="$img(data.value.leftImg.value.url)"
                    @click="$router.pushToTab(data.value.leftImg.value.link.url)" />
            </div>
            <ul class="goods-list">
                <li class="hoverBox hoverBoder" v-for="(item, index) in data.value.goodsList.value.list" :key="index" :title="item.goods_name">
                    <goods-list-item :goods="item" :upDownLayout="true"></goods-list-item>
                </li>
            </ul>
        </div>
        <div class="bottom-wrap" v-if="data.value.bottomImg.value.url">
            <img :src="$img(data.value.bottomImg.value.url)"
                @click="$router.pushToTab(data.value.bottomImg.value.link.url)" />
        </div>
    </div>
</template>

<script>
import { onTip } from "@/utils/tips"
import shareCounter from "@/components/shareCounter.vue"
import ctrlShowText from "@/components/ctrl-show-text/ctrl-show-text.vue";
import goodsPrice from '@/components/goods-price/goods-price.vue';
import { mapGetters } from "vuex";
import goodsListItem from "@/components/goods-list-item/goods-list-item.vue";
export default {
    name: "floor-style-1",
    components: {
        shareCounter,
        ctrlShowText,
        goodsPrice,
        goodsListItem
    },
    props: {
        data: {
            type: Object
        },
        c_index: {
            type: Number
        }
    },
    data() {
        return {
            number: 1
        }
    },
    created() { },
    computed: {
        ...mapGetters(["defaultGoodsImage", "cartCount", "siteInfo", "member"]),
        logined: function () {
            return this.member !== undefined && this.member !== "" && this.member != {}
        }
    },
    methods: {
        upnumber(val) {
            this.number = val
        },
        goSku(item) {
            if (!this.$store.getters.token) {
                this.$router.pushToTab("/login")
                return
            }
            if (onTip(item.sale_control?.view_price, item.sale_control?.is_member_by, this, item.sale_control?.not_buy_msg)) return
            this.$router.pushToTab("/sku-" + item.sku_id)
        },
        // 加入购物车
        joinCart(item,index) {
            if (onTip(item.sale_control.view_price, item.sale_control.is_member_by, this, item.sale_control.not_buy_msg)) return

            this.$store
                .dispatch("cart/add_to_cart", {
                    site_id: item.site_id,
                    sku_id: item.sku_id,
                    num: this.number
                })
                .then(res => {
                    if (res.code === 0) {
                        this.$message({
                            message: "加入购物车成功",
                            type: "success"
                        })
                    }
                })
                .catch(err => {
                    if (err.message === "token不存在") {
                        this.$router.pushToTab("/login")
                    } else {
                        this.$message.error(err.message);
                        if(typeof err.data === 'number'){
                            if(err.data > 0){
                                this.$refs['shareCounter'+index][0].upnumber(err.data);
                                this.$message({
                                    message: "当前数量已更改为可购买数量，请重试加入购物车",
                                    type: "success"
                                });
                            }else{
                                window.location.reload();
                            }
                        }
                    }
                })
        },
        imageError(index) {
            this.data.value.goodsList.value.list[index].goods_image = this.defaultGoodsImage
        }
    }
}
</script>

<style lang="scss">
.floor-style-1 {
    background: #fff;
    margin-top: 20px;
    .head-wrap h2 {
        line-height: 30px;
        color: #333;
        padding: 12px;
        font-size: 18px;
        cursor: pointer;
        width: 95%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-weight: bold;
    }

    .body-wrap {
        display: flex;
        margin-bottom: 12px;

        .left-wrap {
            width: 234px;
            cursor: pointer;
            transition: all 0.2s linear;
            box-sizing: border-box;
            flex-shrink: 0;
            margin-right: 12px;
            img {
                max-width: 100%;
                cursor: pointer;
            }
        }

        .goods-list {
            display: flex;
            flex-wrap: wrap;
            gap: 12px;
            

            .cart-layout {
                padding: 0 19px;
                display: flex;
                justify-content: center;
                align-items: center;

                .el-input-number--mini {
                    width: 85px !important;
                }

                .cart-num {
                    margin-right: 10px;
                    position: relative;
                    width: 30%;
                    border-radius: 4px;
                    display: flex;
                    border: 1px solid #ccc;
                    justify-content: center;
                    align-items: center;

                    span {
                        z-index: 1;
                        position: absolute;
                        cursor: pointer;
                        width: 20px;
                        text-align: center;
                    }

                    span:first-child {
                        left: 0;
                    }

                    span:last-child {
                        right: 0;
                    }

                    .number {
                        .el-input {
                            .el-input__inner {
                                text-align: center;
                            }
                        }
                    }
                }

                .cart-add {
                    font-size: 12px;
                    margin-left: 5px;
                    cursor: pointer;
                    background: $base-color;
                    color: $base-color-whtie;
                    border-radius: 15px;
                    padding: 2px 10px;
                }
                .ban{
                    font-size: 12px;
                    margin-left: 5px;
                    cursor: not-allowed;
                    background:#dddddd6e;
                    color: $base-color-whtie;
                    border-radius: 15px;
                    padding: 2px 10px;
                }
            }

            li {
                width: calc((100% - 48px) / 4);
                background: #fff;
                cursor: pointer;
                padding: 12px;
                border-radius: 12px;
                transition: all 0.2s linear;
                border: 1px solid #dddddd6e;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                gap: 12px;

                &:hover {
                    z-index: 2;
                    -webkit-box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
                    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
                    -webkit-transform: translate3d(0, -2px, 0);
                    transform: translate3d(0, -2px, 0);
                    border: 1px solid #dddddd6e;
                }
            }
        }
    }

    .bottom-wrap {
        margin-top: 10px;
        width: $width;
        //height: 118px;
        cursor: pointer;
        overflow: hidden;

        img {
            max-width: 100%;
        }
    }
}
</style>
